import { string, shape, number } from 'prop-types';

const busMaintenanceBasicInformationPropTypes = {
  id: number.isRequired,
  registeredBusId: number.isRequired,
  registeredBus: shape({
    companyBusId: string.isRequired,
  }),
  originCityId: number.isRequired,
  originCity: shape({
    name: string.isRequired,
  }),
  estimatedArrivalDate: number.isRequired,
  estimatedCompletionDate: number.isRequired,
  observation: string,
  maintenanceStayStatus: string.isRequired,
};

export default busMaintenanceBasicInformationPropTypes;
